import BaseNotFound from './index.vue'

export default {
    install: vm => vm.component('BaseNotFound', BaseNotFound)
}


// WEBPACK FOOTER //
// ./src/components/BaseNotFound/index.js